import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentsSidebarV2ListGroupHeaderLabel = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-group-header-v2-label-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarV2ListGroupHeaderLabel;
